import styled, { css } from '../../../../styles/theme';
import { ButtonStyled } from '../../ButtonStyled';
import { rem } from 'polished';

export const ButtonStyledOV = styled(ButtonStyled)`
    padding: ${rem(10)} ${rem(5)};

    &:hover {
        transition: all 0.3s ease;
    }

    ${({ primary }) =>
        primary &&
        css`
            color: ${({ theme }) => theme.colors.white};
            border: 4px solid ${({ theme }) => theme.colors.primary};
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            &:hover,
            &:focus-visible {
                background: ${({ theme }) => theme.colors.primaryHover};
                color: ${({ theme }) => theme.colors.primary};
            }
        `}

    ${({ secondary }) =>
        secondary &&
        css`
            color: ${({ theme }) => theme.colors.primary};
            border: 2px solid ${({ theme }) => theme.colors.primary};
            background: ${({ theme }) => theme.colors.white};
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            height: ${rem(48)};
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover,
            &:focus-visible {
                background: ${({ theme }) => theme.colors.primary};
                color: ${({ theme }) => theme.colors.white};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.white} !important;
                    }
                }
            }

            svg {
                margin-left: ${rem(5)};
            }
        `}

    ${({ primary, disabled }) =>
        primary &&
        disabled &&
        css`
            border-color: ${({ theme }) => theme.colors.primaryDisabled};
        `}

    ${({ secondary, disabled }) =>
        secondary &&
        disabled &&
        css`
            background: ${({ theme }) => theme.colors.secondaryDisabled};
            border-color: ${({ theme }) => theme.colors.secondaryDisabled};
            color: ${({ theme }) => theme.colors.white};
        `}

    ${({ outline }) =>
        outline &&
        css`
            background: ${({ theme }) => theme.colors.secondaryHover};
            border: 1px solid currentColor;
            color: ${({ theme }) => theme.colors.black};
            font-size: ${({ theme }) => theme.fontSizes.textSubMedium};
            padding: ${rem(10)} ${rem(25)};

            &:hover,
            &:focus-visible {
                background: ${({ theme }) => theme.colors.white};
                color: ${({ theme }) => theme.colors.primary};
            }
        `}

    ${({ fullWidth }) =>
        fullWidth &&
        css`
            width: ${fullWidth ? '100%' : 'auto'};
        `}
`;
